import { render, staticRenderFns } from "./PosDatabaseRecovery.vue?vue&type=template&id=0dc0c272&scoped=true&"
import script from "./PosDatabaseRecovery.vue?vue&type=script&lang=js&"
export * from "./PosDatabaseRecovery.vue?vue&type=script&lang=js&"
import style0 from "./PosDatabaseRecovery.vue?vue&type=style&index=0&id=0dc0c272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc0c272",
  null
  
)

export default component.exports